<div class="container">
    <p class="add-cart-fail">{{errorText}}</p>
    <div>
        <form [formGroup]="addBasketForm" (ngSubmit)="scanBarcode()">
            <table class="center-table" cellspacing="0">
                <tr>
                    <td>
                        <mat-form-field class="center-table" appearance="fill">
                            <mat-label>รหัสสินค้า</mat-label>
                            <input matInput formControlName="barcode" autofocus>
                        </mat-form-field>
                    </td>
                    <td>
                        <button mat-raised-button type="submit" color="primary">GO</button>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <mat-form-field class="full-width" appearance="fill">
                            <mat-label>ค้นหา</mat-label>
                            <input matInput  formControlName="search_key" (keyup)="search($event)"><!--  #input -->
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td>
                        <mat-form-field class="center-table" appearance="fill">
                            <mat-label>จำนวน</mat-label>
                            <input matInput type="number" formControlName="quantity" (change)="updateQTY()">
                        </mat-form-field>
                    </td>
                </tr>
            </table>
        </form>
    </div>
    <mat-grid-list cols="2">
        <mat-grid-tile>
            <!-- <app-search-display [key]="key" [qty]="qty" (barcode)="addBySearch($event)" class="grid-tile"></app-search-display> -->
            <!-- <h2 class="text-head">ผลการค้นหา</h2> -->
            <div class="mat-elevation-z8" id="resual_search" *ngIf="searchResult !== undefined">
                <table mat-table [dataSource]="searchResult" class="mat-elevation-z8">
                    <ng-container matColumnDef="no">
                        <th mat-header-cell *matHeaderCellDef>#</th>
                        <td mat-cell *matCellDef="let index = index"> {{index+1}}</td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>ชื่อสินค้า</th>
                        <td mat-cell *matCellDef="let element">{{element.name}}</td>
                    </ng-container>
                    <ng-container matColumnDef="front_store_price">
                        <th mat-header-cell *matHeaderCellDef class="th-rigth">ราคาหน้าร้าน</th>
                        <td mat-cell *matCellDef="let element" class="th-rigth">{{element.front_store_price}}</td>
                    </ng-container>
                    <ng-container matColumnDef="unit">
                        <th mat-header-cell *matHeaderCellDef class="td-conten-center">หน่วย</th>
                        <td mat-cell *matCellDef="let element" class="td-conten-center">{{element.unit_type}}</td>
                    </ng-container>
                    <ng-container matColumnDef="wholesale_price">
                        <th mat-header-cell *matHeaderCellDef class="th-rigth">ราคาส่ง</th>
                        <td mat-cell *matCellDef="let element" class="th-rigth">{{element.wholesale_price | number:'.2'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="choose">
                        <th mat-header-cell *matHeaderCellDef class="th-rigth">ตัวเลือก</th>
                        <td mat-cell *matCellDef="let element" class="th-rigth">
                            <a>
                                <mat-icon aria-hidden="false" aria-label="add icon" (click)="addBySearch(element.barcode)">add
                                </mat-icon>
                            </a>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsSearch"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsSearch;"></tr>
                </table>
                {{errorText}}
            </div>
        </mat-grid-tile>
        <mat-grid-tile [rowspan]="2">
            <app-cart-display [basket]="basket" [total_price]="total_price" [orderID]="orderID"
                [total_item]="total_item" (order)="setOrder($event)" class="grid-tile"></app-cart-display>
        </mat-grid-tile>
        <mat-grid-tile>
            <app-order-page class="grid-tile" [dataSource]="order" (total)=setTotalPrice($event)
                (data)=setBasketFormOrder($event) (orderID)="setOrderID($event)"></app-order-page>
        </mat-grid-tile>
    </mat-grid-list>
    <div class="quick-borad" (click)="showDiv.previous = !showDiv.previous;">
        <button>
            <p style="writing-mode: tb-rl;padding-top: 7px;">บาร์โค้ด</p>
        </button>
    </div>
    <div *ngIf="showDiv.previous" class="board-box">
        <app-quick-board></app-quick-board>
    </div>
</div>